import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';
const socket = io('https://socket-io.vizion.space/');

const sessionId = window.sessionId;
const ChangeSceneBySocket = ({ onChangeScene }) => {
  const { json } = useSelector((state) => state);

  useEffect(() => {
    console.log(sessionId);
    if (sessionId) {
      socket.emit('joinRoom', sessionId);
    }

    socket.on('receiveChangeSceneCmd', (sceneId) => {
      const groupId = json.scenes.find((scene) => scene.id === sceneId).groupId;
      onChangeScene(groupId, sceneId);
    });

    return () => {
      socket.off('receiveChangeSceneCmd');
    };
  }, [json, onChangeScene]);
  return <></>;
};

export default ChangeSceneBySocket;
